export default __webpack_public_path__ + "static/media/help-rav-inv-21.424bb480.png";